import React, { useState } from 'react';
import styled from 'styled-components';
import { Color, Text } from '../../../styles/common';
import workoutApi from '../../../api/workout';
import Button from '../../../components/common/Button';

function WorkoutInput() {
  const [workout, setWorkout] = useState(''); // 워크아웃 입력
  const isCompleted = false; // 완료 여부: default false
  const timestamp = Number(new Date()); // 정렬 용도라 날짜로 변경 해줄 필요 없다고 판단

  const onWorkoutHandler = (e: React.FormEvent<HTMLInputElement>) => setWorkout(e.currentTarget.value);
  const onSubmitWorkout = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault(); // 새로고침 방지
    if(workout === '') return alert('내용을 입력해 주세요.'); // 공백 입력 시, '내용 입력' 안내하는 alert
    workoutApi.addWorkout(workout, isCompleted, timestamp); // 내용 추가(내용, 완료 여부, 시간)
    setWorkout(''); // 입력창 초기화
  }

  return (
    <Container>
      <form onSubmit={onSubmitWorkout}>
        <input
          type="text"
          value={workout}
          onChange={onWorkoutHandler}
          />
        <Button
          width='100px'
          height='100%'
          color={Color.WHITE}
          fontSize= {Text.SM}
          backgroundColor={Color.BLUE100}
          backgroundColorHover={Color.BLUE200}
        > Send </Button>
      </form>
    </Container>
  )
}

export default WorkoutInput;

const Container = styled.div`
  width: 100%;
  position: absolute;
  bottom: 0;

  form {
    width: 80%;
    height: 30px;
    margin: 0 auto 10px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 10px;

    input {
      width: 100%;
      height: 100%;
      border: none;
      border-bottom: 1px solid ${ Color.GRAY100 };
      outline: none;
    }
  }
`